export class EntityActionsTrackers {
  static readonly ENTITY_ACTION_CONFIRM_CLICKED = '[Entity Action] confirm clicked';

  static readonly ENTITY_ACTION_CANCEL_CLICKED = '[Entity Action] cancelled clicked';

  static readonly ENTITY_ACTION_ERRORED = '[Entity Action] action errored';

  static readonly ENTITY_ACTION_SUCCESS = '[Entity Action] action success';
}
